import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state() {
    return {
      groupUsers: [], // API'den gelen grup-kullanıcı verisi
      allUsers: [], // Düzleştirilmiş tüm kullanıcılar
      answerRateAnalyticData: [],
      answerTotalRateAnalyticData: [],
      touchingRateAnalyticData: null, // MT Temas Oranı verisi
      operationalEfficiencyData: null, // MT Operasyonel Verimlilik verisi
      dailyOperationalEfficiencyData: {}, // MT Günlük Operasyon Verimliliği verisi - widget ID'ye göre object
      // Widget-specific data storage
      widgetData: {} // Her widget'ın verilerini widget ID'ye göre saklayacak
    }
  },
  getters,
  mutations,
  actions
}